import styled from 'styled-components'

import { media } from '../../../../../styles/breakpoints'

import { ScanHealthFloorSelector } from './ScanHealthFloorSelector'

export const SCAN_HEALTH_SIDE_RAIL_TOP = '160px'

interface ScanHealthLeftRailProps {
  floors: Parameters<typeof ScanHealthFloorSelector>[0]['floors']
  selectedFloorCodes: Set<string>
  onToggleFloor: (floorCode: string, checked: boolean) => void
  onSelectAll: () => void
  onDeselectAll: () => void
  expanded: boolean
  setExpanded: (value: boolean) => void
}

export const ScanHealthLeftRail = (props: ScanHealthLeftRailProps) => (
  <RailInner data-scan-health-selector>
    <ScanHealthFloorSelector {...props} />
  </RailInner>
)

const RailInner = styled.div`
  width: 250px;
`

export const DesktopLeftRail = styled.aside`
  position: fixed;
  left: 24px;
  top: ${SCAN_HEALTH_SIDE_RAIL_TOP};
  width: 250px;
  z-index: 12;
  max-height: calc(100vh - ${SCAN_HEALTH_SIDE_RAIL_TOP} - 24px);
  overflow-y: auto;

  @media ${media.belowTablet} {
    display: none;
  }
`

export const MobileLeftRail = styled.div`
  display: none;

  @media ${media.belowTablet} {
    display: block;
    width: 100%;
    margin-bottom: 12px;
  }
`
